import React from 'react';
import PropTypes from 'prop-types';
import { BaseHalfCalendarButton, BaseCalendarButton, Text } from '../common';
import CalendarButtonContainer from './CalendarButtonContainer';

const renderContent = (
  title,
  holiday,
  specialItemToRender,
  renderFunction,
  selected,
  disabled,
  hasMultipleSpecialItem
) => {
  if (!!specialItemToRender && renderFunction) {
    return renderFunction(
      specialItemToRender,
      disabled,
      selected,
      hasMultipleSpecialItem
    );
  }

  const { title: holidayTitle } = holiday || {};

  return (
    <React.Fragment>
      {title && <Text>{title}</Text>}
      {holidayTitle && (
        <Text fontSize={['8px', 0]} textAlign={['center', 'left']}>
          {holidayTitle}
        </Text>
      )}
    </React.Fragment>
  );
};

function CalendarButton(props) {
  const {
    holiday,
    title,
    specialItem,
    renderSpecialItem,
    selected,
    disabled,
    date,
    onSelect,
    isSelectionDisabled,
    selectedExtractor,
    ...restProps
  } = props;

  let itemToRender = specialItem;
  let hasMultipleSpecialItem = false;

  if (Array.isArray(specialItem)) {
    itemToRender = specialItem[0];
    hasMultipleSpecialItem = specialItem.length > 1;
  }

  const overrideStyle = {};

  if (isSelectionDisabled) {
    overrideStyle.cursor = 'auto';
  }

  if (hasMultipleSpecialItem) {
    return (
      <CalendarButtonContainer>
        {specialItem.map((item, index) => {
          let isSelected = isSelected;
          if (selectedExtractor) {
            isSelected = selectedExtractor(item);
          }
          return (
            <BaseHalfCalendarButton
              key={index}
              selected={isSelected}
              disabled={disabled}
              {...restProps}
              style={overrideStyle}
            >
              {renderContent(
                title,
                holiday,
                item,
                renderSpecialItem,
                isSelected,
                disabled,
                hasMultipleSpecialItem
              )}
            </BaseHalfCalendarButton>
          );
        })}
      </CalendarButtonContainer>
    );
  }

  return (
    <CalendarButtonContainer>
      <BaseCalendarButton
        selected={selected}
        disabled={disabled}
        {...restProps}
        onClick={() => onSelect && onSelect(date)}
        style={overrideStyle}
      >
        {renderContent(
          title,
          holiday,
          itemToRender,
          renderSpecialItem,
          selected,
          disabled
        )}
      </BaseCalendarButton>
    </CalendarButtonContainer>
  );
}

CalendarButton.propTypes = {
  holiday: PropTypes.object,
  icon: PropTypes.string,
  title: PropTypes.string,
  selected: PropTypes.bool,
  date: PropTypes.object,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  specialItem: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  renderSpecialItem: PropTypes.func,
  isSelectionDisabled: PropTypes.bool,
  selectedExtractor: PropTypes.func
};

CalendarButton.defaultProps = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center'
};

export default CalendarButton;
